export default "__VITE_ASSET__HnYVZPUf__"